import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="marketing-page min-h-screen bg-background">
      <Navigation />

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="flex items-center gap-3 mb-6">
          <FileText className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold">{t("terms.title")}</h1>
            <p className="text-muted-foreground">
              {t("terms.lastUpdated", { date: new Date().toLocaleDateString() })}
            </p>
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t("terms.sections.agreement.title")}</CardTitle>
            <CardDescription>{t("terms.sections.agreement.body")}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.acceptance.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.acceptance.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.description.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.description.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.accounts.title")}</h3>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>{t("terms.sections.accounts.items.accurate")}</li>
                <li>{t("terms.sections.accounts.items.security")}</li>
                <li>{t("terms.sections.accounts.items.noSharing")}</li>
                <li>{t("terms.sections.accounts.items.notify")}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.acceptableUse.title")}</h3>
              <p className="text-muted-foreground mb-2">{t("terms.sections.acceptableUse.intro")}</p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>{t("terms.sections.acceptableUse.items.illegal")}</li>
                <li>{t("terms.sections.acceptableUse.items.harass")}</li>
                <li>{t("terms.sections.acceptableUse.items.malware")}</li>
                <li>{t("terms.sections.acceptableUse.items.unauthorized")}</li>
                <li>{t("terms.sections.acceptableUse.items.spam")}</li>
                <li>{t("terms.sections.acceptableUse.items.record")}</li>
                <li>{t("terms.sections.acceptableUse.items.offensive")}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.content.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.content.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.recording.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.recording.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.privacy.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.privacy.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.payments.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.payments.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.availability.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.availability.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.liability.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.liability.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.indemnification.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.indemnification.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.termination.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.termination.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.changes.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.changes.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.governingLaw.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.governingLaw.body")}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-2">{t("terms.sections.contact.title")}</h3>
              <p className="text-muted-foreground">
                {t("terms.sections.contact.body")}
              </p>
              <ul className="list-none pl-0 text-muted-foreground mt-2">
                <li>{t("terms.sections.contact.items.company")}</li>
                <li>{t("terms.sections.contact.items.email")}</li>
                <li>{t("terms.sections.contact.items.phone")}</li>
                <li>{t("terms.sections.contact.items.website")}</li>
              </ul>
            </section>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
}


